export default "__VITE_ASSET__CkSM27He__"